import type { NewsItem } from "@/lib/workUtils";

interface NewsSectionProps {
  items: NewsItem[];
}

export default function NewsSection({ items }: NewsSectionProps) {
  return (
    <section>
      <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
        <span className="h-5 w-1.5 rounded-full bg-accent-500" />
        影视更新与资讯
      </h2>
      <div className="mt-5 space-y-3">
        {items.map((item, index) => (
          <article
            key={index}
            className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
          >
            <div className="flex flex-wrap items-center gap-3">
              <span className="rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-800">
                {index === 0 ? "资料更新" : index === 1 ? "主创访谈" : "相关动态"}
              </span>
              <span className="text-xs text-foreground-500">{item.date}</span>
            </div>
            <h3 className="mt-2 font-heading text-sm font-bold text-foreground-950 md:text-base">
              {item.title}
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
              {item.summary}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}